import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { ServerDataSource } from 'angular2-smart-table';
import { Model } from './common/.base.model';
import { EntityConfigTemplate } from './common/entity-config.interface';
import { FormConfigTemplate } from './common/form-config-template.interface';

const dPipe = new DatePipe('en');

export interface PayrollPeriod extends Model {
  name: string;
  startDate: string;
  endDate: string;
  status: 'draft' | 'processing' | 'completed' | 'cancelled';
  payrollFrequency?: 'Monthly' | 'Fortnightly' | 'Weekly' | 'Bimonthly';
  frappeId?: string;
  runDate?: string;
}

export const PayrollPeriodConfig: EntityConfigTemplate = {
  meta: {
    entityName: 'Payroll Period',
    entityPluralName: 'payroll/periods',
    titleField: 'name',
    view: false,
  },
  name:      { title: 'Period Name' },
  startDate: { title: 'Start Date', type: 'date', valuePrep: (cell, _) => dPipe.transform(cell, 'MMM dd, yyyy') ?? cell },
  endDate:   { title: 'End Date',   type: 'date', valuePrep: (cell, _) => dPipe.transform(cell, 'MMM dd, yyyy') ?? cell },
  cycles: { title: '# of Payroll Cycles', valuePrep: (cell, _) => cell?.length ?? 0 },
};

export const PayrollPeriodFormConfig: FormConfigTemplate = {
  tabs: [
    {
      title: 'Period Details',
      columns: [
        {
          size: 'col-12',
          type: 'form',
          sections: [
            {
              title: 'Payroll Period',
              rows: [
                {
                  fields: [
                    { name: 'name', label: 'Period Name', type: 'text', required: true, size: 'col-12', placeholder: 'e.g. April 2026' },
                  ],
                },
                {
                  fields: [
                    { name: 'startDate', label: 'Start Date', type: 'date', required: true, size: 'col-6' },
                    { name: 'endDate',   label: 'End Date',   type: 'date', required: true, size: 'col-6' },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export abstract class PayrollPeriodData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<PayrollPeriod[]>;
  abstract listAll(): Observable<PayrollPeriod[]>;
  abstract get(id: string): Observable<PayrollPeriod>;
  abstract update(period: PayrollPeriod): Observable<PayrollPeriod>;
  abstract create(period: Partial<PayrollPeriod>): Observable<PayrollPeriod>;
  abstract delete(id: string): Observable<boolean>;
}
